import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Collapse } from "reactstrap";
import navdata from "../LayoutMenuData";
import withRouter from "../../Components/Common/withRouter";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

const VerticalLayout = (props) => {
  const navData = navdata().props.children;
  const path = props.router.location.pathname;

  const selectLayoutState = (state) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      leftsidbarSizeType: layout.leftsidbarSizeType,
      sidebarVisibilitytype: layout.sidebarVisibilitytype,
      layoutType: layout.layoutType,
    })
  );

  const { leftsidbarSizeType, sidebarVisibilitytype, layoutType } = useSelector(
    selectLayoutProperties
  );

  const resizeSidebarMenu = useCallback(() => {
    var windowSize = document.documentElement.clientWidth;
    if (windowSize >= 1025) {
      if (["vertical", "semibox"].includes(document.documentElement.getAttribute("data-layout"))) {
        document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
      }
      const hamburgerIcon = document.querySelector(".hamburger-icon");
      if (hamburgerIcon) {
        if (sidebarVisibilitytype === "show" || layoutType === "vertical" || layoutType === "twocolumn") {
          hamburgerIcon.classList.remove("open");
        } else {
          hamburgerIcon.classList.add("open");
        }
      }
    } else if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove("twocolumn-panel");
      if (["vertical", "semibox"].includes(document.documentElement.getAttribute("data-layout"))) {
        document.documentElement.setAttribute("data-sidebar-size", "sm");
      }
      document.querySelector(".hamburger-icon")?.classList.add("open");
    } else if (windowSize <= 767) {
      document.body.classList.remove("vertical-sidebar-enable");
      if (document.documentElement.getAttribute("data-layout") !== "horizontal") {
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
      document.querySelector(".hamburger-icon")?.classList.add("open");
    }
  }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

  useEffect(() => {
    window.addEventListener("resize", resizeSidebarMenu, true);
    return () => window.removeEventListener("resize", resizeSidebarMenu);
  }, [resizeSidebarMenu]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const resolveMatchingPath = (menuPath, currentPath) => {
      const aliases = {
        "/dashboard": ["/dashboard", "/accounting-dashboard"],
        "/real-time": ["/real-time", "/map-view"],
        "/trip-list": ["/trip-list", "/trip-details/:id"],
        "/user-permissions": ["/user-permissions", "/add-permissions", "/add-permissions/:id"],
        "/maintenance": ["/maintenance", "/media/insurance/:id/:file", "/media/maintenance/:id/:file"],
        "/vehicle-management": ["/vehicle-management", "/vehicle-details/:id"],
      };

      const normalizePath = (path) => path.replace(/\/:\w+/g, "");

      if (aliases[menuPath]) {
        return aliases[menuPath].some(alias => {
          const base = normalizePath(alias);
          return currentPath.startsWith(base);
        });
      }

      return currentPath.startsWith(normalizePath(menuPath));
    };

    const initMenu = () => {
      const ul = document.getElementById("navbar-nav");
      if (!ul) return;
      const items = ul.getElementsByTagName("a");
      let itemsArray = [...items];
      removeActivation(itemsArray);

      let matchingMenuItem = itemsArray.find((x) => {
        const pathname = x.pathname.replace(process.env.PUBLIC_URL, "");
        return resolveMatchingPath(pathname, path);
      });

      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };

    if (props.layoutType === "vertical") {
      initMenu();
    }
  }, [path, props.layoutType]);

  const activateParentDropdown = (item) => {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      parentCollapseDiv.classList.add("show");
      const parentLink = parentCollapseDiv.parentElement.children[0];
      parentLink.classList.add("active");
      parentLink.setAttribute("aria-expanded", "true");

      const grandParentCollapse = parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown");
      if (grandParentCollapse) {
        grandParentCollapse.classList.add("show");
        const grandParentLink = grandParentCollapse.previousElementSibling;
        if (grandParentLink) grandParentLink.classList.add("active");

        const greatGrandParentCollapse = grandParentLink?.closest(".collapse");
        if (greatGrandParentCollapse) {
          greatGrandParentCollapse.classList.add("show");
          greatGrandParentCollapse.previousElementSibling?.classList.add("active");
        }
      }
    }
  };

  const removeActivation = (items) => {
    let actiItems = items.filter((x) => x.classList.contains("active"));

    actiItems.forEach((item) => {
      item.classList.remove("active");
      item.setAttribute("aria-expanded", false);
      if (item.nextElementSibling) item.nextElementSibling.classList.remove("show");
    });
  };

  return (
    <React.Fragment>
      {(navData || []).map((item, key) => {
        return (
          <React.Fragment key={key}>
            {item.isHeader ? (
              <li className="menu-title">
                <span data-key="t-menu">{item.label}</span>
              </li>
            ) : item.subItems ? (
              <li className="nav-item">
                <Link
                  onClick={item.click}
                  className="nav-link menu-link"
                  to={item.link || "/#"}
                  data-bs-toggle="collapse"
                >
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                  {item.badgeName && (
                    <span className={`badge badge-pill bg-${item.badgeColor}`}>
                      {item.badgeName}
                    </span>
                  )}
                </Link>
                <Collapse className="menu-dropdown" isOpen={item.stateVariables} id="sidebarApps">
                  <ul className="nav nav-sm flex-column">
                    {(item.subItems || []).map((subItem, subKey) => (
                      <li className="nav-item" key={subKey}>
                        <Link
                          to={subItem.link || "/#"}
                          className="nav-link"
                        >
                          {subItem.label}
                          {subItem.badgeName && (
                            <span className={`badge badge-pill bg-${subItem.badgeColor}`}>
                              {subItem.badgeName}
                            </span>
                          )}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Collapse>
              </li>
            ) : (
              <li className="nav-item">
                <Link className="nav-link menu-link" to={item.link || "/#"}>
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                  {item.badgeName && (
                    <span className={`badge badge-pill bg-${item.badgeColor}`}>
                      {item.badgeName}
                    </span>
                  )}
                </Link>
              </li>
            )}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

VerticalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(VerticalLayout);
